import { Link } from "react-router-dom";
import { api } from "../api";
import { useAuth } from "../auth";
import { useLoad } from "../hooks";

export function HomePage() {
  const { user } = useAuth();
  if (!user) return null;
  if (user.role === "patient" && user.patient_id !== null) return <PatientHome patientId={user.patient_id} />;
  return <StaffHome />;
}

function StaffHome() {
  const notes = useLoad(() => api.notifications(), []);
  return (
    <>
      <h1>Overview</h1>
      <div className="card">
        <p><Link to="/patients">Patients</Link> — find a patient, see their history, start a session.</p>
        <p><Link to="/stations">Stations</Link> — register a display and calibrate it.</p>
      </div>
      <h2>Notifications</h2>
      <div className="card">
        {notes.data?.length ? (
          <table>
            <thead><tr><th>When</th><th>Message</th><th /></tr></thead>
            <tbody>
              {notes.data.map((n) => (
                <tr key={n.id} className={n.read ? "muted" : ""}>
                  <td className="small">{new Date(n.created_at).toLocaleString()}</td>
                  <td><pre style={{ margin: 0, whiteSpace: "pre-wrap", fontFamily: "inherit" }}>{n.message}</pre></td>
                  <td>
                    {n.session_id && <Link to={`/sessions/${n.session_id}`}>Open</Link>}{" "}
                    {!n.read && <button className="link" onClick={() => api.markRead(n.id).then(notes.reload)}>Mark read</button>}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : <p className="muted">Nothing yet.</p>}
      </div>
    </>
  );
}

function PatientHome({ patientId }: { patientId: number }) {
  const sessions = useLoad(() => api.patientSessions(patientId), [patientId]);
  return (
    <>
      <h1>Your vision tests</h1>
      <div className="card">
        <p>Sit at your marked distance, in your usual room lighting, with any glasses you normally wear for distance.</p>
        <Link to={`/patients/${patientId}/new-session`}><button>Start a test</button></Link>
        <p className="small" style={{ marginBottom: 0 }}><Link to="/setup?again=1">Set up again</Link>: Chrome, your monitor,
          brightness, the card and a practice.</p>
      </div>
      <h2>Your results</h2>
      <div className="card">
        {sessions.data?.length ? (
          <ul>
            {sessions.data.map((s) => (
              <li key={s.id}><Link to={`/sessions/${s.id}`}>{new Date(s.started_at).toLocaleDateString()}</Link> <span className="muted">({s.status})</span></li>
            ))}
          </ul>
        ) : <p className="muted">No tests yet.</p>}
      </div>
    </>
  );
}
